import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
// Footer style
classname = "ct-footer footer-dark";
ftlogo = "assets/img1/logo.png"
  constructor() { }

  ngOnInit(): void {
  }

}
